export default "__VITE_ASSET__381d2703__"